import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import enTranslations from './locales/en.json';
import ruTranslations from './locales/ru.json';
import hyTranslations from './locales/hy.json';

const resources = {
  en: { translation: enTranslations },
  ru: { translation: ruTranslations },
  hy: { translation: hyTranslations },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'hy', // Default language: Armenian
    fallbackLng: 'hy',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
  });

export default i18n;
